import { create } from 'zustand'

type State = {
  dialogType: SkuTypes.TypeInfo | ''
  dialogFrom: string
  selectState: boolean
  loading: boolean
}

type Action = {
  dialogShow: (payload?: {
    type: SkuTypes.TypeInfo
    from?: string
  }) => void
  setLoading: (x: boolean) => void
  selectShow: (payload: boolean) => void
}

const DrawerStore = create<State & Action>((set) => ({
  dialogType: '',
  dialogFrom: '',
  selectState: false,
  loading: false,
  setLoading: (status) => {
    set(state => ({
      ...state,
      loading: status
    }))
  },
  // sku面板
  dialogShow: (payload) => {
    if (payload) {
      const { type, from } = payload;
      set(state => {
        // 关闭
        if (state.dialogType) {
          // 去除新版Header滚动
          document.body.classList.remove('no-scroll');
          // 去除老版Header滚动
          document.querySelector('html')?.classList.remove('no-scroll');
          return {
            ...state,
            selectState: false,
            dialogType: ''
          }
        }
        // 打开
        document.body.classList.add('no-scroll');
        document.querySelector('html')?.classList.add('no-scroll');
        return {
          ...state,
          dialogFrom: from,
          dialogType: type
        }
      })
    } else {
      set(state => {
        // 去除新版Header滚动
        document.body.classList.remove('no-scroll');
        // 去除老版Header滚动
        document.querySelector('html')?.classList.remove('no-scroll');
        return {
          ...state,
          selectState: false,
          dialogType: ''
        }
      })
    }
  },
  // 选择列表展示
  selectShow: (payload) => {
    set(state => ({
      ...state,
      selectState: payload
    }))
  }
}))

export default DrawerStore;